<template>
  <master-layout pageTitle="Integrations">
    <div>
      <div class="chat-toolbar">
        <div class="toolbar-start">
          <VIcon @click="() => $router.go(-1)" name="arrow-left-line" :size="-4" class="cursorPointer"></VIcon>
          <h2 class="prdt-title">{{ moengageSocialData?.appname || moengageSocialData?.account_name || 'MoEngage Settings' }}</h2>
        </div>
        <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Save Settings" @click="saveConnectorDetails"></VButton>
      </div>

      <div>
        <div class="channel-container gridMargin">
          <div class="cust_brdr optionsContainer flexContainer">
            <div class="flexContainer">
              <img src="../../resources/images/moengage-logo.png" width="40" alt="moengage_logo" class="iconImg"/>
              <h2 class="header">{{ moengageSocialData?.appname || moengageSocialData?.account_name || 'MoEngage' }}</h2>
            </div>
            <VButton class="vvd-btn-danger-outline" connotation="announcement" appearance="outlined" label="Disconnect" @click="() => disconnectPageMode = true"></VButton>
          </div>

          <!-- Connector Details Form -->
          <div class="tab-content">
            <div class="optionsContainer cust_brdr">
              <p class="sub-title paddingBottom no-margin">Sender Name</p>
              <div class="field-row">
                <VTextField :modelValue="connectorDetails.senderName" readonly appearance="ghost" class="vivid-input" aria-label="Sender name"></VTextField>
                <VIcon name="copy-2-line" :size="-5" class="copy-icon cursorPointer" @click="copyToClipboard(connectorDetails.senderName)" />
              </div>
            </div>

            <div class="optionsContainer cust_brdr">
              <p class="sub-title paddingBottom no-margin">WhatsApp Business Number</p>
              <div class="field-row">
                <VTextField :modelValue="whatsAppSocialData ? `${whatsAppSocialData.country_code} ${whatsAppSocialData.mobile_number}` : ''" readonly placeholder="No WhatsApp connected" appearance="ghost" class="vivid-input" aria-label="WhatsApp number"></VTextField>
                <VIcon v-if="whatsAppSocialData" name="copy-2-line" :size="-5" class="copy-icon cursorPointer" @click="copyToClipboard(whatsAppSocialData ? `${whatsAppSocialData.country_code}${whatsAppSocialData.mobile_number}` : '')" />
              </div>
            </div>

            <div class="optionsContainer cust_brdr">
              <p class="sub-title paddingBottom no-margin">Authorization</p>
              <div class="field-row">
                <VTextField :modelValue="connectorDetails.authorization" :type="showAuthToken ? 'text' : 'password'" readonly placeholder="Click generate to create authorization token" appearance="ghost" class="vivid-input" aria-label="Authorization token"></VTextField>
                <VIcon :name="showAuthToken ? 'eye-hide-line' : 'eye-line'" :size="-5" class="copy-icon cursorPointer" @click="toggleAuthTokenVisibility" v-if="connectorDetails.authorization" />
                <span class="generate-btn cursorPointer" @click="() => generateTokenConfirm = true">Generate</span>
                <VIcon v-if="connectorDetails.authorization" name="copy-2-line" :size="-5" class="copy-icon cursorPointer" @click="copyToClipboard(connectorDetails.authorization)" />
              </div>
            </div>

            <div class="optionsContainer cust_brdr">
              <p class="sub-title paddingBottom no-margin">API URL</p>
              <div class="field-row">
                <VTextField :modelValue="connectorDetails.apiUrl" readonly appearance="ghost" class="vivid-input" aria-label="API URL"></VTextField>
                <VIcon name="copy-2-line" :size="-5" class="copy-icon cursorPointer" @click="copyToClipboard(connectorDetails.apiUrl)" />
              </div>
            </div>

            <div class="optionsContainer cust_brdr">
              <p class="sub-title paddingBottom no-margin">DLR Webhook URL</p>
              <div class="field-row">
                <VTextField v-model="connectorDetails.dlrWebhookUrl" placeholder="Enter DLR webhook URL" appearance="ghost" class="vivid-input" aria-label="DLR Webhook URL" icon="open-line"></VTextField>
              </div>
            </div>

            <div>
              <div class="webhook-header">
                <div>
                  <p class="sub-title">MoEngage Webhook</p>
                  <p class="webhook-description">Enable connector to send message delivery status back to MoEngage</p>
                </div>
                <VSwitch :checked="webhookEnabled" connotation="cta" @change="handleWebhookToggle" :disabled="isWebhookLoading" />
              </div>

              <div v-if="isWebhookLoading" class="webhook-status">
                <VProgressRing class="vvd-spinner vvd-spinner-sm" connotation="cta" indeterminate />
                <span class="status-text">{{ webhookLoadingMessage }}</span>
              </div>

              <div v-else-if="webhookEnabled" class="webhook-status success">
                <VIcon name="check-circle-line" :size="-5" style="color: #10dc60;" />
                <span class="status-text">Connector is active. Delivery status updates will be sent to MoEngage.</span>
              </div>

              <div v-else class="webhook-status disabled">
                <VIcon name="warning-line" :size="-5" style="color: #92949c;" />
                <span class="status-text">Connector is inactive. Enable to send message delivery status back to MoEngage.</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Generate Token Confirmation -->
      <VDialog :open="generateTokenConfirm" headline="Generate New Authorization Token?" modal @close="() => generateTokenConfirm = false">
        <template #body>
          <p class="vtext-body">Generating a new token will replace the existing one and may temporarily disrupt active MoEngage integrations. Any running campaigns or services using the current token will need to be updated. Are you sure you want to continue?</p>
        </template>
        <template #action-items>
          <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => generateTokenConfirm = false"></VButton>
          <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Generate Token" @click="() => { generateTokenConfirm = false; generateAuthorization(); }"></VButton>
        </template>
      </VDialog>

      <!-- Disconnect Confirmation -->
      <VDialog :open="disconnectPageMode" headline="Are you sure?" modal @close="() => disconnectPageMode = false">
        <template #body>
          <p class="vtext-body">You want to disconnect your MoEngage account?</p>
        </template>
        <template #action-items>
          <VButton class="vvd-btn-cancel" appearance="filled" label="Cancel" @click="() => disconnectPageMode = false"></VButton>
          <VButton class="vvd-btn-primary" connotation="cta" appearance="filled" label="Yes" @click="disconnectMoEngage"></VButton>
        </template>
      </VDialog>
    </div>
  </master-layout>
</template>

<script>
import { environment } from '@/shared/env.js';
import { useUIStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';
import { useSocialChannels } from '@/composables/useSocialChannels';
import apiInterceptor from '@/shared/apiInterceptor';

export default {
  name: 'MoEngageSettings',
  setup() {
    const { whatsAppSocialData } = useSocialChannels();
    return { whatsAppSocialData };
  },
  data() {
    return {
      disconnectPageMode: false,
      generateTokenConfirm: false,
      showAuthToken: false,
      webhookEnabled: false,
      isWebhookLoading: false,
      webhookLoadingMessage: '',
      connectorDetails: {
        senderName: 'Jumper Communications',
        authorization: '',
        apiUrl: `${environment('VUE_APP_MOENGAGE_API_URL')}queue-connect-message`,
        dlrWebhookUrl: ''
      }
    };
  },
  computed: {
    moengageSocialData() {
      return null;
    }
  },
  async mounted() {
    await this.fetchShopConfig();
    await this.checkWebhookStatus();
  },
  methods: {
    async fetchShopConfig() {
      try {
        if (!useAuthStore().cleanUserData?.referallshopName) {
          console.warn('Shop name not available, skipping config fetch');
          return;
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Loading configuration...' });
        const apiBaseUrl = `${environment('VUE_APP_API_URL')}settings`;
        const response = await apiInterceptor.get(`${apiBaseUrl}/v1/moengage/config-shop/${useAuthStore().cleanUserData?.referallshopName}`);
        if (response) {
          this.connectorDetails = {
            ...this.connectorDetails,
            senderName: response.app_name || this.connectorDetails.senderName,
            authorization: response.moengage_jumper_app_token || '',
            dlrWebhookUrl: response.dlr_web_hook_url || ''
          };
        }
      } catch (error) {
        console.error('Fetch Shop Config Error:', error);
        if (error.response?.data?.status === 'failure' && error.response.data.error?.code === '4004') {
          return;
        }
        useUIStore().updateToast({ open: true, message: 'Failed to load configuration. Using default values.', type: 'warning' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async copyToClipboard(text) {
      if (!text) return;
      try {
        await navigator.clipboard.writeText(text);
        useUIStore().updateToast({ open: true, message: 'Copied to clipboard!', type: 'success' });
      } catch (err) {
        useUIStore().updateToast({ open: true, message: 'Failed to copy to clipboard', type: 'danger' });
      }
    },
    async generateAuthorization() {
      try {
        useUIStore().updateLoading({ isLoading: true, message: 'Generating authorization token...' });
        const apiBaseUrl = `${environment('VUE_APP_API_URL')}settings`;
        const response = await apiInterceptor.post(`${apiBaseUrl}/v1/moengage/connector-token/${useAuthStore().cleanUserData?.referallshopName}`);
        this.connectorDetails.authorization = response.token;
        useUIStore().updateToast({ open: true, message: 'Authorization token generated successfully!', type: 'success' });
      } catch (error) {
        console.error('Generate Authorization Error:', error);
        useUIStore().updateToast({ open: true, message: error.response?.data?.message || 'Failed to generate authorization token', type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async saveConnectorDetails() {
      try {
        if (!useAuthStore().cleanUserData?.referallshopName) {
          useUIStore().updateToast({ open: true, message: 'Shop name is not available.', type: 'danger' });
          return;
        }
        if (this.connectorDetails.dlrWebhookUrl) {
          const urlRegex = /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*?(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
          if (!urlRegex.test(this.connectorDetails.dlrWebhookUrl)) {
            useUIStore().updateToast({ open: true, message: 'Please enter a valid DLR webhook URL.', type: 'danger' });
            return;
          }
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Saving connector details...' });
        const apiBaseUrl = `${environment('VUE_APP_API_URL')}settings`;
        const payload = {
          dlr_web_hook_url: this.connectorDetails.dlrWebhookUrl || "",
          moengage_jumper_app_token: this.connectorDetails.authorization || "",
          wa_business_number: this.whatsAppSocialData?.mobile_number || ""
        };
        await apiInterceptor.put(`${apiBaseUrl}/v1/moengage/config-shop/${useAuthStore().cleanUserData?.referallshopName}`, payload);
        useUIStore().updateToast({ open: true, message: 'Shop configuration updated successfully', type: 'success' });
      } catch (error) {
        console.error('Save Connector Details Error:', error);
        const errorMessage = error.response?.data?.error?.message || error.message || 'Something went wrong while saving configuration.';
        useUIStore().updateToast({ open: true, message: errorMessage, type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
      }
    },
    async disconnectMoEngage() {
      try {
        if (!useAuthStore().cleanUserData?.referallshopName) {
          useUIStore().updateToast({ open: true, message: 'Shop name is not available.', type: 'danger' });
          return;
        }
        useUIStore().updateLoading({ isLoading: true, message: 'Disconnecting MoEngage...' });
        const apiBaseUrl = `${environment('VUE_APP_API_URL')}settings`;
        await apiInterceptor.post(`${apiBaseUrl}/v1/moengage/disconnect/${useAuthStore().cleanUserData?.referallshopName}`);
        useUIStore().updateToast({ open: true, message: 'MoEngage disconnected successfully!', type: 'success' });
        this.$router.replace('/integrations');
      } catch (error) {
        console.error('Disconnect MoEngage Error:', error);
        const errorMessage = error.response?.data?.error?.message || error.message || 'Failed to disconnect MoEngage.';
        useUIStore().updateToast({ open: true, message: errorMessage, type: 'danger' });
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        this.disconnectPageMode = false;
      }
    },
    toggleAuthTokenVisibility() {
      this.showAuthToken = !this.showAuthToken;
    },
    async checkWebhookStatus() {
      try {
        this.isWebhookLoading = true;
        this.webhookLoadingMessage = 'Checking webhook status...';
        const moengageWebhookUrl = `${environment('VUE_APP_MOENGAGE_API_URL')}dlr-status-update`;
        const apiBaseUrl = environment('VUE_APP_API_URL');
        const response = await apiInterceptor.get(`${apiBaseUrl}developer-portal/v1/webhooks`);
        let webhooksList = response?.webhooks || (Array.isArray(response) ? response : []);
        if (webhooksList.length > 0) {
          const moengageWebhook = webhooksList.find(webhook => webhook.url === moengageWebhookUrl && webhook.is_valid === true);
          this.webhookEnabled = !!moengageWebhook;
        } else {
          this.webhookEnabled = false;
        }
      } catch (error) {
        console.error('Check Webhook Status Error:', error);
        this.webhookEnabled = false;
      } finally {
        this.isWebhookLoading = false;
        this.webhookLoadingMessage = '';
      }
    },
    handleWebhookToggle(event) {
      const isEnabled = event.target?.checked ?? event.detail?.checked;
      if (isEnabled && !this.webhookEnabled) {
        this.enableWebhook();
      } else if (!isEnabled && this.webhookEnabled) {
        // User tried to disable webhook - prevent it
        useUIStore().updateToast({
          open: true,
          message: 'Webhook management is available in Developer Portal Settings. Please navigate there to disable this webhook.',
          type: 'warning',
          duration: 5000 // Show for 5 seconds to give user time to read
        });
        
        // Reset the toggle back to enabled after a brief moment
        setTimeout(() => {
          this.webhookEnabled = false;
          this.$nextTick(() => { this.webhookEnabled = true; });
        }, 50);
      }
    },
    async enableWebhook() {
      try {
        // Validation check
        if (!useAuthStore().cleanUserData?.referallshopName) {
          useUIStore().updateToast({
            open: true,
            message: 'Shop name is not available.',
            type: 'danger'
          });
          this.webhookEnabled = false;
          return;
        }
        this.isWebhookLoading = true;
        this.webhookLoadingMessage = 'Enabling webhook...';
        const apiBaseUrl = `${environment('VUE_APP_API_URL')}settings`;
        await apiInterceptor.post(`${apiBaseUrl}/v1/moengage/create-webhook/${useAuthStore().cleanUserData?.referallshopName}`);
        this.webhookEnabled = true;
        
        useUIStore().updateToast({
          open: true,
          message: 'MoEngage webhook enabled successfully!',
          type: 'success'
        });
        
      } catch (error) {
        console.error('Enable Webhook Error:', error);
        this.webhookEnabled = false;
        
        let errorMessage = 'Failed to enable webhook. Please try again.';
        
        if (error.response?.data?.status === 'failure') {
          const errorData = error.response.data.error;
          errorMessage = errorData?.message || errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }
        
        useUIStore().updateToast({
          open: true,
          message: errorMessage,
          type: 'danger'
        });
      } finally {
        this.isWebhookLoading = false;
        this.webhookLoadingMessage = '';
      }
    }
  }
};
</script>

<style scoped>
.chat-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-bottom: 1px solid var(--background-primary);
  background: var(--white);
}
.toolbar-start {
  display: flex;
  align-items: center;
  gap: 12px;
}
.prdt-title {
  padding-left: 0px;
  margin: 0;
}
.backBttn {
  color: var(--black);
}
.channel-container {
  background: var(--white);
  border-radius: 5px;
  padding: 20px;
}
.flexContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}
.iconImg {
  width: 40px;
  height: 40px;
  border-radius: 5px;
}
.header {
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: var(--black);
  margin: 0;
}
.tab-content {
  min-height: 400px;
}
.field-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.vivid-input {
  background: var(--background-primary);
  border-radius: 5px;
  min-height: 40px;
  flex: 1;
}
.copy-icon {
  color: var(--purple);
  flex-shrink: 0;
}
.generate-btn {
  color: var(--purple);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.webhook-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.webhook-description {
  margin: 4px 0 0 0;
  font-size: 14px;
  color: var(--gray-04);
}
.webhook-status {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: var(--background-primary);
}
.webhook-status.success {
  background-color: rgba(16, 220, 96, 0.1);
}
.webhook-status.disabled {
  background-color: rgba(128, 128, 128, 0.1);
}
.webhook-status .status-text {
  font-size: 14px;
  color: var(--black);
  line-height: 1.4;
}
@media only screen and (max-width: 760px) {
  .channel-container {
    margin: 10px;
    padding: 15px;
  }
  .flexContainer {
    gap: 10px;
  }
}
</style>
